import {Service} from "@/apiServices/Service";

export class PtiPresuntivoService extends Service {

    constructor() {
        super('ptipresuntivo/');
    }

    obtenerCatalogosDientes(nino,adutlo) {
        this.onStart();
        return this.http.get(this.getUrl(['obtener','catalogo', 'dientes'], {nino,adutlo}))
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }


    obtenerDatosGenerales(lngIdPTI) {
        this.onStart();
        return this.http.get(this.getUrl(['obtener', 'datosGenerales'], {lngIdPTI}))
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    calcularRutasEspecialidades(idDenticion, data) {
        return this.http.put(this.getUrl(['calcular', 'rutas', 'especialidades'], {idDenticion}),data)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerPlanesOrtodoncia(idPti) {
        this.onStart();
        return this.http.get(this.getUrl(['obtener','planes','ortodoncia'], {idPti}))
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenertratamientosPadeciminetosCentralizados(params) {
        this.onStart();
        return this.http.post(this.getUrl(['obtener','tratamientos','configurados','descentralizada']), params)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerTramientosPorClinica(clinicas) {
        this.onStart();
        return this.http.post(this.getUrl(['obtener','tratamientos','denticion']), clinicas)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerTramientosKitsPorClinica(clinicas) {
        this.onStart();
        return this.http.post(this.getUrl(['obtener','tratamientos','kits','denticion']), clinicas)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }


    guardarDeserializado(datos) {
        this.onStart();
        return this.http.post(this.getUrl(['guardar','hdx','deserializado']), datos)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerNivel(datos) {
        this.onStart();
        return this.http.post(this.getUrl(['obtenerNivel']), datos)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    guardarBorrador(datos, numero) {
        this.onStart();
        return this.http.post(this.getUrl(['guardar','borrador'], {numero}), datos)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    guardarValidacionDeserializado(datos) {
        this.onStart();
        return this.http.post(this.getUrl(['guardar','hdx','validacion','deserializado']), datos)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerInformacionHDX(parametros) {
        this.onStart();
        return this.http.post(this.getUrl(['obtener','hdx','deserializado']),parametros)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerInformacionCDX(idPti) {
        this.onStart();
        return this.http.post(this.getUrl(['obtener','hdx','deserializado-cdx']),idPti)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerInformacionHDXPti(idPti) {
        this.onStart();
        return this.http.post(this.getUrl(['obtener','hdx','deserializado','pti']),idPti)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerkits() {
        this.onStart();
        return this.http.get(this.getUrl(['obtener','kits'],),)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerRutaClinica(dientes) {
        this.onStart();
        return this.http.post(this.getUrl(['obtener','ruta-clinica'],),dientes)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerDentticion(params) {
        this.onStart();
        return this.http.post(this.getUrl(['obtener','denticion']),params)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

   /* obtenerEnfermedades(idPaciente) {
        this.onStart();
        return this.http.get(this.getUrl(['obtener','enfermedades'],{idPaciente}))
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }*/

    obtenerBorradores(params) {
        this.onStart();
        return this.http.post(this.getUrl(['obtener','borradores']), params)
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerBorrador(params) {
        this.onStart();
        return this.http.post(this.getUrl(['obtener','borrador']), params)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }

    eliminarBorrador(params) {
        this.onStart();
        return this.http.post(this.getUrl(['eliminar','borrador'],), params)
            .then((response) => this.onData(response))
            .then((response) => this.onData(response))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
}